import { LoaderService } from './base-services/loader.service';
import { AccountConfirm } from './base-components/register/account-confirm.component';
import { AccountCreated } from './base-components/register/account-created.component';
import { RegisterComponent } from './base-components/register/register.component';
import { RegisterV2Component } from './base-components/register/register-v2.component';
import { YtLoader } from './base-components/loader/loader.component';
import { TableContextMenuContainerDirective } from './base-components/default-table/table-context-menu-container.directive';
import { YtUpload } from './base-components/upload/upload.component';
import { DefaultListFilter } from './base-components/default-list-filter/default-list-filter.component';
import { FilterContainerDirective } from './base-components/default-list/filter-container.directive';
import { ControlsContainerDirective } from './base-components/dropdown/cascade-dropdown/controls-container.directive';
import { CascadeDropdownComponent } from './base-components/dropdown/cascade-dropdown/cascade-dropdown.component';
import { SideMenuV2Component } from './base-components/side-menu-v2/side-menu-v2.component';
import { MultiselectComponent } from './base-components/dropdown/multiselect/multiselect.component';
import { PseudoComponent } from './base-components/pseudo-component/pseudo.component';
import { GetPropertyValuePipe } from './pipes/get-property-value.pipe';
import { RebateSwitchComponent } from './base-components/rebate-switch/rebate-switch.component';
import { NumberInputComponentV2 } from './base-components/input/number-input/number-input-v2.component';
import { NumberInputComponentV1 } from './base-components/input/number-input/number-input-v1.component';
import { CompanySelectorComponent } from './base-components/company-selector/company-selector.component';
import { TopMenu } from './base-components/top-menu/top-menu.component';
//import { YtKontrolaPoModulu97 } from './validators/yt-kontrola-po-modulu-97';
import { TextAreaComponent } from './base-components/input/text-area/text-area.component';
import { InputComponent } from './base-components/input/input/input.component';
import { DefaultDetailListInlineComponent } from './base-components/default-detail-list/default-detail-list-inline.component';
import { DefaultDetailListModalComponent } from './base-components/default-detail-list/default-detail-list.component';
import { Breadcrumbs } from './base-components/breadcrumbs/breadcrumbs.component';
import { ErrorHandlerService } from './base-services/error-handler.service';
import { DropDownControlButtonsComponent } from './base-components/dropdown/dropdown-buttons/drop-down-control-buttons.component';
import { LoginComponent } from './base-components/login/login.component';
import { LoginV2Component } from './base-components/login/login-v2.component';
import { RouterModule } from '@angular/router';
import { ApiInterceptorService } from './base-services/api-interceptor.service';
import { AuthenticationService } from './base-services/authentication.service';
import { BaseDataService } from './base-services/base-data.service';
import { ConfigService } from './base-services/config.service';
import { NgModule, InjectionToken, ErrorHandler, forwardRef } from '@angular/core';
import { YtNgFrameworkComponent } from './yt-ng-framework.component';
import { ModalSize } from './base-models/modal-size';
import { DefaultListButtonsComponent } from './base-components/default-list-buttons/default-list-buttons.component';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DefaultListTabsComponent } from './base-components/default-list/default-list-tabs.component';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { BaseDefaultListComponent } from './base-components/default-list/base-default-list.component';
import { DefaultTableComponent } from './base-components/default-table/default-table.component';
import { DefaultUpdateButtonsComponent } from './base-components/default-update-buttons/default-update-buttons.component';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { SetHeightDirective } from './directives/set-height.directive';
import { DefaultListModalComponent } from './base-components/default-list/default-list-modal.component';
import { ModalService } from './base-services/modal.service';
import { TabsContainerService } from './base-classes/containers/services/tabs-container.service';
import { StopClickPropagationDirective } from './directives/stop-click-propagation.directive';
import { SideMenuComponent } from './base-components/side-menu/side-menu.component';
import { DefaultHeaderComponent } from './base-components/default-header/default-header.component';
import { AppContentComponent } from './base-components/app-content/app-content.component';
import { DefaultFooterComponent } from './base-components/default-footer/default-footer.component';
import { DropdownComponent } from './base-components/dropdown/dropdown.component';
import { DatePickerPopup2Component } from './base-components/date-picker-popup/date-picker-popup.component';
// import { ModuleWithProviders } from '@angular/compiler/src/core';
import { BaseContainerService } from './base-classes/containers/services/base-container-service';
import { UserService } from './base-services/user.service';
import { NotifierModule, NotifierService } from 'angular-notifier';
// import { SimpleNotificationsModule } from 'angular2-notifications';
import { YtErrorHandler } from './base-services/yt-error-handler';
import { ServerErrorInterceptor } from './base-services/server-error-interceptor';
import { DropdownPicklistComponent } from './base-components/dropdown/dropdownPicklist/dropdownPicklist.component';
import { DefaultTreeViewComponent } from './base-components/default-tree-view/default-tree-view.component';
import { TreeviewModule } from 'ngx-treeview';
import { AutocompleteComponent } from './base-components/autocomplete/autocomplete.component';
import { ZrcComponent } from './base-components/zrc/zrc.component';
import { NumberInputComponent } from './base-components/input/number-input/number-input.component';
import { NumberInputComponentV3 } from './base-components/input/number-input/number-input-v3.component';
import { ConfirmationDialog } from './base-components/confirmation-dialog/confirmation-dialog.component';
import { PrintDialog } from './base-components/print-dialog/print-dialog.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DefaultListPageComponent } from './base-components/default-list/default-list-page.component';
import { ExportService } from './base-services/export.service';
import { IsVisibleDirective } from './directives/is-visible.directive';
import { RowColorDirective } from './directives/row-color.directive';
import { RadioButtonsGroupComponent } from './base-components/radio-buttons-group/radio-buttons-group.component';
import { DateRangePickerPopupComponent } from './base-components/date-range-picker-popup/date-range-picker-popup.component';
import { GridWithEditingComponent } from './base-components/editable-grid/editable-grid.component';
import { YtChart } from './base-components/chart/chart.component';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { InfoBox } from './base-components/info-box/info-box.component';
import { UserRightsService } from './base-services/user-rights.service';
import { DefgIniService } from './base-services/defg-ini.service';
import { ForgottenPasswordComponent } from './base-components/forgotten-password/forgotten-password.component';
import { ResetPasswordComponent } from './base-components/reset-password/reset-password.component';
import { AddLeadingZerosDirective } from './directives/addLeadingZeros.directive';
import { ButtonComponent } from './base-components/button/button.component';
import { ShowPasswordDirective } from './directives/show-password.directive';
import { NumberInputComponentV4 } from './base-components/input/number-input/number-input-v4.component';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
// import { DateTimePickerPopupComponent } from './base-components/date-time-picker-popup/date-time-picker-popup.component';
import { PromoDialog } from './base-components/promo-dialog/promo-dialog.component';
import { YtEditorComponent } from './base-components/input/yt-editor/yt-editor.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { UserNotify } from './base-models/user-notify';
// import { BaseModalUpdateComponent } from '../public_api';
import { DefaultListTabsInUpdateComponent } from './base-components/default-list/default-list-tabs-in-update.component';
import { TextAreaModalComponent } from './base-components/input/text-area/text-area-modal.component';
import { Tabs2ContainerService } from './base-classes/containers/services/tabs2-container.service';
import { ContextMenuComponent } from './base-components/context-menu/context-menu.component';
// import { ToastrModule } from 'ngx-toastr';
import { ModuleWithProviders } from '@angular/core';
import { NotificationService } from './base-services/notification-service';
import { DateTimePickerPopupComponent } from './base-components/date-time-picker-popup/date-time-picker-popup.component';
import { PaginationComponent } from './base-components/pagination/pagination.component';
import { InputHtmlComponent } from './base-components/input/input-html/input-html.component';
import { SearchBoxComponent } from './base-components/search-box/search-box.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { SignalRService } from './base-services/signalr.service';
import { PleaseWaitComponent } from './base-components/please-wait/please-wait.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/translate/', '.json');
}

@NgModule({
  imports: [
    HttpClientModule,
    NgbModule,
    CommonModule,
    FormsModule,
    RouterModule, 
    ReactiveFormsModule,
    // TranslateModule.forChild(),
    TranslateModule,
    TreeviewModule,
    NgMultiSelectDropDownModule.forRoot(),
    ChartsModule,
    RecaptchaV3Module,
    AngularEditorModule
    // NgbModalModule
    // ,ToastrModule
    ],
  
  declarations: [
    YtNgFrameworkComponent, 
    DefaultListButtonsComponent, 
    DefaultListTabsComponent, 
    BaseDefaultListComponent, 
    DefaultTableComponent, 
    DefaultUpdateButtonsComponent, 
    SetHeightDirective, 
    DefaultListModalComponent, 
    StopClickPropagationDirective, 
    SideMenuComponent, 
    DefaultHeaderComponent, 
    AppContentComponent, 
    DefaultFooterComponent, 
    DropdownComponent, 
    LoginComponent, LoginV2Component,
    DatePickerPopup2Component, 
    DropDownControlButtonsComponent, 
    Breadcrumbs, 
    DefaultDetailListModalComponent, 
    DefaultDetailListInlineComponent, 
    InputComponent, 
    TextAreaComponent, 
    DropdownPicklistComponent, 
    DefaultTreeViewComponent, 
    AutocompleteComponent, 
    ZrcComponent, 
    TopMenu, 
    NumberInputComponentV1, 
    NumberInputComponentV2, 
    NumberInputComponentV3, 
    CompanySelectorComponent, 
    RebateSwitchComponent, 
    GetPropertyValuePipe,
    PseudoComponent,
    ConfirmationDialog,
    PrintDialog,
    MultiselectComponent,
    SideMenuV2Component,
    DefaultListPageComponent,
    IsVisibleDirective,
    RowColorDirective,
    CascadeDropdownComponent,
    ControlsContainerDirective,
    FilterContainerDirective,
    DefaultListFilter,
    YtUpload,
    RadioButtonsGroupComponent,
    TableContextMenuContainerDirective,
    YtLoader,
    RegisterComponent, RegisterV2Component,
    AccountCreated,
    AccountConfirm,
    DateRangePickerPopupComponent,
    GridWithEditingComponent,
    YtChart,
    InfoBox,
    ForgottenPasswordComponent,
    ResetPasswordComponent,
    AddLeadingZerosDirective,
    ButtonComponent,
    ShowPasswordDirective,
    NumberInputComponentV4,
    PromoDialog,
    YtEditorComponent,    
    DefaultListTabsInUpdateComponent,
    TextAreaModalComponent,
    ContextMenuComponent,
    DateTimePickerPopupComponent,
    PaginationComponent,
    InputHtmlComponent,
    SearchBoxComponent,
    PleaseWaitComponent
  ],

  exports: [
    YtNgFrameworkComponent, 
    DefaultListTabsComponent, 
    DefaultUpdateButtonsComponent, 
    DefaultListModalComponent, 
    SideMenuComponent,
    DefaultHeaderComponent, 
    AppContentComponent, 
    DefaultFooterComponent, 
    DropdownComponent, 
    LoginComponent, LoginV2Component,
    DatePickerPopup2Component, 
    Breadcrumbs, 
    DefaultDetailListModalComponent, 
    DefaultDetailListInlineComponent, 
    InputComponent, 
    TextAreaComponent,
    TextAreaModalComponent, 
    DropdownPicklistComponent, 
    DefaultTreeViewComponent, 
    AutocompleteComponent, 
    ZrcComponent, 
    DefaultTableComponent, 
    NumberInputComponentV1, 
    NumberInputComponentV2, 
    NumberInputComponentV3, 
    CompanySelectorComponent, 
    RebateSwitchComponent,
    //, NotifierModule
    MultiselectComponent,
    SideMenuV2Component,
    DefaultListPageComponent,
    IsVisibleDirective,
    CascadeDropdownComponent,
    YtUpload,
    RadioButtonsGroupComponent,
    YtLoader,
    RegisterComponent, RegisterV2Component,
    AccountCreated,
    AccountConfirm,
    DateRangePickerPopupComponent,
    GridWithEditingComponent,
    YtChart,
    InfoBox,
    ForgottenPasswordComponent,
    ResetPasswordComponent,
    AddLeadingZerosDirective,
    ButtonComponent,
    ShowPasswordDirective,
    NumberInputComponentV4,
    PromoDialog,
    DateTimePickerPopupComponent,
    YtEditorComponent,
    // AngularEditorModule,
    DefaultListButtonsComponent,
    BaseDefaultListComponent,
    FilterContainerDirective,
    DefaultListTabsInUpdateComponent,
    ConfirmationDialog,
    PaginationComponent,
    InputHtmlComponent,
    SearchBoxComponent
    , TranslateModule
    , PleaseWaitComponent
  ],
  
//  entryComponents: [PrintDialog]
  // ,
  // entryComponents: [
  //   ConfirmationDialog,
  //   PrintDialog,
  //   DropdownPicklistComponent,
  //   PromoDialog,
  //   YtEditorComponent,
  //   TextAreaModalComponent
  // ]

  //providers:[
    //BaseDataService,
    //AuthenticationService,
    //{
      //provide: HTTP_INTERCEPTORS,
      //useClass: ApiInterceptorService,
      //multi: true
    //},
    //DatePipe,
    //ModalService
    //TabsContainerService
  //]

  // , providers:[
  //   {
  //     provide: NG_VALUE_ACCESSOR,
  //     useExisting: DateTimePickerPopupComponent,
  //     multi: true
  //   } 
  // ]
})
export class YtNgFrameworkModule { 
  static forRoot(): ModuleWithProviders<YtNgFrameworkModule> {
    return {
      ngModule: YtNgFrameworkModule,
      providers: [ 
        { provide: ConfigService, useClass: ConfigService },
        { provide: BaseDataService, useClass: BaseDataService },
        { provide: AuthenticationService, useClass: AuthenticationService },
        { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptorService, multi: true },
        { provide: DatePipe, useClass: DatePipe },
        { provide: ModalService, useClass: ModalService },
        { provide: TabsContainerService, useClass: TabsContainerService },
        { provide: Tabs2ContainerService, useClass: Tabs2ContainerService },
        { provide: BaseContainerService, useClass: BaseContainerService },
        { provide: DecimalPipe, useClass: DecimalPipe },
        { provide: UserService, useClass: UserService},
        { provide: UserNotify, useClass: UserNotify},
        //{ provide: NotifierService, useClass: NotifierService}
        { provide: ErrorHandler, useClass: YtErrorHandler },
        { provide: ErrorHandlerService, useClass: ErrorHandlerService},
        { provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true},
        { provide: GetPropertyValuePipe, useClass: GetPropertyValuePipe, multi: true},
        ExportService//,
        //{ provide: LoaderService, useClass: LoaderService, multi: true}
        , UserRightsService,
        DefgIniService,
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LepYfglAAAAAHysLbf9g6GvG97ZDKPdHAvaBrLn' },
        ThemeService
      ]
    }
  }
}
